import Layout from '@/views/Layout/index.vue';
const StudentPage = () => import('@/views/StudentPage/index.vue');

const Management = () => import('@/views/StudentPage/Management/index.vue');
const StudentDetail = () => import('@/views/StudentPage/StudentDetail/index.vue');
const Renewal = () => import('@/views/StudentPage/Renewal/index.vue');
const Record = () => import('@/views/StudentPage/Record/index.vue');

export default {
  path: '/student',
  component: Layout,
  children: [
    {
      path: '',
      component: StudentPage,
      children: [
        {
          path: '',
          component: Management,
        },
        {
          path: 'studentdetail',
          component: StudentDetail,
        },
        {
          path: 'renewal',
          component: Renewal,
        },
        {
          path: 'record',
          component: Record,
        }
      ]
    }
  ]
}
